import React from "react";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaWhatsapp } from "react-icons/fa";
import { InView } from 'react-intersection-observer';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-16 w-full">
      <div className="container mx-auto px-6 w-full">

        {/* Logo and Description */}
        <InView triggerOnce={true} threshold={0.5}>
          {({ inView, ref }) => (
            <div ref={ref} className={`flex justify-between items-center mb-10 ${inView ? 'animate__animated animate__fadeIn' : ''}`}>
              <div className="flex items-center">
                <img src="/Subtract.png" alt="EDIT EZY" className="w-16 h-16 mr-4 rounded-full" />
                <p className="text-lg">
                  EDIT EZY is your go-to platform for creating professional and stunning posters for events, promotions, and more.
                  We offer creative design services that help your brand stand out.
                </p>
              </div>
            </div>
          )}
        </InView>

        {/* Footer Links */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-10">

          {/* About EDIT EZY Section */}
          <InView triggerOnce={true} threshold={0.5}>
            {({ inView, ref }) => (
              <div ref={ref} className={`${inView ? 'animate__animated animate__fadeIn' : ''}`}>
                <h3 className="text-xl font-semibold mb-4">About EDIT EZY</h3>
                <ul className="text-sm space-y-2">
                  <li><a href="/" className="hover:text-blue-500">Home</a></li>
                  <li><a href="/about-us" className="hover:text-blue-500">About Us</a></li>
                  <li><a href="/privacy-policy" className="hover:text-blue-500">Privacy Policy</a></li>
                </ul>
              </div>
            )}
          </InView>

          {/* Disabled Links Section */}
          <InView triggerOnce={true} threshold={0.5}>
            {({ inView, ref }) => (
              <div ref={ref} className={`${inView ? 'animate__animated animate__fadeIn' : ''}`}>
                <h3 className="text-xl font-semibold mb-4">Services We Offer</h3>
                <ul className="text-sm space-y-2 text-gray-400">
                  <li><span className="cursor-not-allowed" style={{ pointerEvents: 'none' }}>Custom Poster Design</span></li>
                  <li><span className="cursor-not-allowed" style={{ pointerEvents: 'none' }}>Event Posters</span></li>
                  <li><span className="cursor-not-allowed" style={{ pointerEvents: 'none' }}>Business Promotion Posters</span></li>
                  <li><span className="cursor-not-allowed" style={{ pointerEvents: 'none' }}>Social Media Posters</span></li>
                  <li><span className="cursor-not-allowed" style={{ pointerEvents: 'none' }}>Flyers & Brochures</span></li>
                </ul>
              </div>
            )}
          </InView>

          {/* Social Media Icons */}
          <InView triggerOnce={true} threshold={0.5}>
            {({ inView, ref }) => (
              <div ref={ref} className={`${inView ? 'animate__animated animate__fadeIn' : ''}`}>
                <h3 className="text-xl font-semibold mb-4">Follow Us on Social Media</h3>
                <div className="flex space-x-4">
                  <FaFacebook size={30} className="text-white" />
                  <FaTwitter size={30} className="text-white" />
                  <FaInstagram size={30} className="text-white" />
                  <FaLinkedin size={30} className="text-white" />
                  <FaWhatsapp size={30} className="text-white" />
                </div>
              </div>
            )}
          </InView>
        </div>

        {/* Footer Bottom */}
        <div className="border-t border-gray-700 pt-6 mt-6 flex justify-between items-center">
          <p className="text-sm text-center sm:text-left">© EDIT EZY All Rights Reserved, 2025.</p>
          <div className="flex space-x-4 ml-2">
            <FaFacebook size={20} className="text-white" />
            <FaTwitter size={20} className="text-white" />
            <FaInstagram size={20} className="text-white" />
            <FaLinkedin size={20} className="text-white" />
            <FaWhatsapp size={20} className="text-white" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
